import React from "react";
import axios from "axios";
import { VERIFY_TOKEN_API } from "../Constants/Apis";
import { getToken } from "../Utils/CommonUtils";
import { HTTP_STATUS_OK } from "../Constants/HttpStatusConstants";
import NavBar from "../components/layouts/AuthenticatedWebLayout/User/NavBar/NavBar";
import AuthenticatedPage from "../components/layouts/AuthenticatedPage/AutheticatedPage";

class UserRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      name: "",
      username: "",
      counterCode: "",
      dept: "",
      roles: [],
    };
  }

  async componentDidMount() {
    const { history } = this.props;
    await this.authenticateToken(history);
  }

  authenticateToken = async (history) => {
    try {
      const token = getToken();
      console.log("Retrieved Token:", token);

      if (!token) {
        console.log("No token found, redirecting to login");
        localStorage.removeItem("token");
        return history.push("/login");
      }

      const response = await axios.get(`${VERIFY_TOKEN_API}/${token}`);
      console.log("Token Verification Response:", response.data);

      const decodedToken = response?.data?.decodedToken;
      const dateIsExpired = Date.now() >= decodedToken.exp * 1000;
      const verifyFail = response.status !== HTTP_STATUS_OK;

      if (verifyFail || dateIsExpired) {
        console.log("Token expired or invalid, redirecting to login");
        localStorage.removeItem("token");
        return history.push("/login");
      }

      this.setState({
        authenticated: true,
        username: decodedToken?.username,
        name: decodedToken?.name,
        roles: decodedToken?.roles || [],
        counterCode: decodedToken?.counterCode || "N/A",
        dept: decodedToken?.dept || "N/A",
      });

      console.log("Authenticated successfully:", this.state);
    } catch (error) {
      console.error("Error verifying token:", error);
      localStorage.removeItem("token");
      this.setState({ authenticated: false });
      return history.push("/login");
    }
  };

  render() {
    const { authenticated, name, username, counterCode, dept, roles } =
      this.state;
    const { history } = this.props;

    return authenticated ? (
      <div>
        <NavBar history={history} userData={this.state} />
        <AuthenticatedPage history={history} userData={this.state} />
      </div>
    ) : null;
  }
}

export default UserRoutes;
